import { Reveal, Overline, Chapter } from "../components/Reveal";
import { PartnerForm } from "../components/EnquiryForms";

const POINTS = [
    { t: "Relevant Demand", c: "Projects are placed with briefed, qualified buyers — not circulated to unfiltered audiences." },
    { t: "Structured Project Presentation", c: "Every project is documented with location, pricing and product context, so commercial conversations start informed." },
    { t: "Long-Term Relationships", c: "We build repeat distribution relationships with developers and partners across India and Dubai." },
];

const ForPartners = () => (
    <main data-testid="for-partners-page">
        <section className="bg-charcoal pb-20 pt-40 text-ivory md:pb-28 md:pt-52">
            <div className="mx-auto max-w-[1400px] px-6 md:px-12">
                <Reveal>
                    <Overline>For Developers &amp; Partners</Overline>
                    <h1 className="mt-6 max-w-3xl font-serif text-5xl font-light leading-[1.02] tracking-tight sm:text-6xl">
                        Built for Better Real Estate <span className="italic text-gold">Partnerships.</span>
                    </h1>
                    <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-ivory/70">
                        LUXATI works with developers, sales teams and real-estate partners on structured
                        distribution — placing selected projects in front of qualified buyer and investor
                        demand.
                    </p>
                </Reveal>
            </div>
        </section>

        <section className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 md:py-32">
            <div className="grid gap-12 md:grid-cols-3">
                {POINTS.map((p, i) => (
                    <Reveal key={p.t} delay={i * 0.12} className="border-t border-ink/15 pt-8">
                        <p className="font-serif text-sm italic text-gold">{String(i + 1).padStart(2, "0")}</p>
                        <h3 className="mt-3 font-serif text-2xl font-medium tracking-tight text-ink">{p.t}</h3>
                        <p className="mt-4 text-sm font-light leading-relaxed text-ink/65">{p.c}</p>
                    </Reveal>
                ))}
            </div>
        </section>

        <section className="border-t border-ink/10 bg-white/50">
            <div className="mx-auto grid max-w-[1400px] gap-16 px-6 py-24 md:grid-cols-12 md:px-12 md:py-36">
                <div className="md:col-span-5">
                    <Chapter number="01" label="Partnership Enquiry" />
                    <Reveal className="mt-10">
                        <h2 className="font-serif text-4xl font-light leading-[1.08] tracking-tight text-ink sm:text-5xl">
                            Partner With <span className="italic text-gold">LUXATI.</span>
                        </h2>
                        <p className="mt-8 max-w-md text-base font-light leading-relaxed text-ink/70">
                            Tell us about your project, your market and your distribution goals. We will
                            respond with how LUXATI can fit into your sales ecosystem.
                        </p>
                    </Reveal>
                </div>
                <Reveal delay={0.15} className="md:col-span-6 md:col-start-7 md:pt-20">
                    <PartnerForm testid="partners-partner-form" />
                </Reveal>
            </div>
        </section>
    </main>
);

export default ForPartners;
